import { render, staticRenderFns } from "./productBenefitAction.vue?vue&type=template&id=1235fb40&"
import script from "./productBenefitAction.vue?vue&type=script&lang=js&"
export * from "./productBenefitAction.vue?vue&type=script&lang=js&"
import style0 from "./productBenefitAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports